export default __webpack_public_path__ + "static/media/pullman-singapore-orchard-slider.a140adf6.jpg";